<template>
	<div class="question-group  px-1">
		<slot />
	</div>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
	name: 'question-group'
})
</script>

<style lang="scss" scoped>
.question-group {
	background: transparent;
	border-radius: var(--radius-sm);
	padding: 0;
	margin-bottom: 8px;

	// Remove bottom margin from last child to prevent extra spacing
	:deep(.step-section-card:last-child) {
		margin-bottom: 0 !important;
	}

	// Also handle any other potential last child elements
	& > *:last-child {
		margin-bottom: 0 !important;
	}
}
</style>
